import BackendService from './BackendService';

async function getVariantDimensions() {
  return BackendService.getData(`/items/variant-dimensions/`);
}

async function getVariantDimension(variantId) {
  return BackendService.getData(`/items/variant-dimensions/${variantId}/`);
}

async function createVariantDimension(data) {
  return BackendService.postData('/items/variant-dimensions/', data);
}

async function updateVariantDimension(variantId, data) {
  return BackendService.patch(`/items/variant-dimensions/${variantId}/`, data);
}

async function deleteVariantDimension(variantId) {
  return BackendService.destroy(`/items/variant-dimensions/${variantId}/`);
}

async function createVariantLabel(data) {
  return BackendService.postData('/items/variant-labels/', data);
}

async function updateVariantLabel(labelId, data) {
  return BackendService.patch(`/items/variant-labels/${labelId}/`, data);
}

async function getVariantLabels(params = {}) {
  return BackendService.getData('/items/variant-labels/', {}, params);
}

async function deleteVariantLabel(labelId) {
  return BackendService.destroy(`/items/variant-labels/${labelId}/`);
}

async function createProductVariantMappings(data = {}) {
  return BackendService.postData('/items/variant-mappings/', data);
}

async function getProductVariantMappings(params = {}) {
  return BackendService.getData('/items/variant-mappings/', {}, params);
}

async function deleteProductVariantMapping(id) {
  return BackendService.destroy(`/items/variant-mappings/${id}/`);
}

async function createBaseProducts(data = {}) {
  return BackendService.postData('/products/', data);
}

async function getBaseProducts(params = {}) {
  return BackendService.getData('/products/', {}, params);
}

const VariantService = {
  getVariantDimensions,
  getVariantDimension,
  createVariantDimension,
  updateVariantDimension,
  deleteVariantDimension,
  createVariantLabel,
  updateVariantLabel,
  getVariantLabels,
  deleteVariantLabel,
  getProductVariantMappings,
  createProductVariantMappings,
  deleteProductVariantMapping,
  createBaseProducts,
  getBaseProducts,
};

export default VariantService;
